module.exports = __webpack_public_path__ + "img/04-xjtu-wneu-polimi-logo.f673abfd.png";